import { Button, FormElement } from "@/components";
import { checkValidateSchemas } from "@/shared/validation";
import { FONT, MEDIA } from "@/styles/common";
import { Flex, Text } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";

export const CheckForm = ({ onSubmit }: { onSubmit: (data: any) => void }) => {
    const { control, handleSubmit } = useForm<{ orderNum: string; orderTel: string }>({
        resolver: yupResolver(checkValidateSchemas),
        defaultValues: {
            orderNum: "",
            orderTel: "",
        },
    });

    const { isMobile } = MEDIA();
    return (
        <Flex w={isMobile ? "100%" : "auto"} flexDir="column" rowGap="16px">
            <CustomTitle>예약조회</CustomTitle>
            <CustomFlex
                w={isMobile ? "100%" : "548px"}
                p={isMobile ? "0" : "36px"}
                gap="36px"
                isMobile={isMobile}
                flexDir={"column"}
            >
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Flex flexDir={"column"} gap="24px">
                        <FormElement
                            widthSize="full"
                            control={control}
                            type="text"
                            placeholder="전화번호 끝 네자리 ex) 0000"
                            name="orderTel"
                            id="orderTel"
                            label="연락처"
                            value=""
                            isRequired={true}
                        />
                        <FormElement
                            widthSize="full"
                            control={control}
                            type="text"
                            placeholder="예약번호 ex) MM0000"
                            name="orderNum"
                            id="orderNum"
                            label="예약번호"
                            value=""
                            isRequired={true}
                        />
                        <CustomButton>예약 조회하기</CustomButton>
                    </Flex>
                </form>
            </CustomFlex>
        </Flex>
    );
};

const CustomFlex = styled(Flex)<{ isMobile: boolean }>`
    border: ${({ isMobile, theme }) => (isMobile ? "none" : `1px solid ${theme.COLOR.gray[300]}`)};
    border-radius: 16px;
`;

const CustomButton = styled(Button)`
    border: ${({ theme }) => `1px solid ${theme.COLOR.gray[300]}`};
`;

const CustomTitle = styled(Text)`
    ${FONT("pretendard", 24, 700, 1.5)}
`;
